export const validationsState = {
  data: {},
  error: null,
  loading: true,
}
